import * as Types from '@frameio/graphql-client/generated/types';

import { TypedDocumentNode as DocumentNode } from '@graphql-typed-document-node/core';
import gql from 'graphql-tag';
import { CompleteImages } from '../../../../graphql-client/graphql/_global/fragments/generated/CompleteImages';

import { useQuery, useLazyQuery, useMutation, useFragment, useSubscription } from '@apollo/client';
import type { QueryHookOptions, LazyQueryHookOptions, MutationHookOptions, SubscriptionHookOptions, UseFragmentOptions } from '@apollo/client';

export type WorkspaceBasicInfoFragment = { __typename?: 'Workspace', id: string, isWorkfront?: boolean | null, name: string, externallyManagedIntegration?: { __typename?: 'ExternallyManagedIntegration', integration?: Types.Integration | null, canUpdateInternalAssetContentSecurity: boolean, canUpdateWorkspaceName: boolean } | null, images?: { __typename?: 'Images', image32?: string | null, image64?: string | null, image128?: string | null, image256?: string | null, imageBase?: string | null, original?: string | null } | null };

export const WorkspaceBasicInfo = /*#__PURE__*/ gql`
    fragment WorkspaceBasicInfo on Workspace {
  externallyManagedIntegration @client {
    integration
    canUpdateInternalAssetContentSecurity
    canUpdateWorkspaceName
  }
  id
  images {
    ...CompleteImages
  }
  isWorkfront
  name
}
    ${CompleteImages}` as unknown as DocumentNode<WorkspaceBasicInfoFragment, unknown>;

        

        
export const useWorkspaceBasicInfoFragment = (
  input: string | Omit<UseFragmentOptions<WorkspaceBasicInfoFragment, any>, 'fragment' | 'fragmentName'> | undefined | null
) => {
  const options = (() => {
    if (!input) return { from: null };
    if (typeof input === 'string') return { from: { id: input, __typename: 'Workspace' } };
    return input;
  })();

  return useFragment<WorkspaceBasicInfoFragment>({
    fragment: WorkspaceBasicInfo,
    fragmentName: 'WorkspaceBasicInfo',
    ...options,
  });
};
  
        